import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/images/hero-bg.jpg"
          alt="绿色能源背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left - Text content */}
            <div className="text-background-50">
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
                绿证供需对接
                <br />
                <span className="text-primary-300">高效 · 透明 · 免费</span>
              </h1>
              <p className="text-background-100/80 text-base md:text-lg mt-5 leading-relaxed max-w-lg">
                纯免费信息撮合平台，不参与交易、资金、权属过户。
                专注为绿证供应与需求企业搭建高效对接桥梁，助力企业绿色低碳转型。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 mt-8">
                <Link
                  to="/supply-publish"
                  className="group px-7 py-3.5 bg-background-50 text-foreground-900 text-sm font-semibold rounded-md hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
                >
                  我要出售
                  <span className="w-6 h-6 rounded-full border border-foreground-900 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
                <Link
                  to="/demand-publish"
                  className="group px-7 py-3.5 border border-background-50/40 text-background-50 text-sm font-semibold rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
                >
                  我要购买
                  <span className="w-6 h-6 rounded-full border border-background-50/40 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
              </div>
            </div>

            {/* Right - Visual area with subtle decorative element */}
            <div className="hidden lg:flex items-center justify-center">
              <div className="relative w-full aspect-square max-w-md">
                <div className="absolute inset-0 bg-primary-500/10 rounded-full blur-3xl"></div>
                <div className="relative w-full h-full flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-32 h-32 mx-auto rounded-full bg-background-50/10 backdrop-blur-sm flex items-center justify-center border border-background-50/20">
                      <i className="ri-shield-check-line text-5xl text-background-50"></i>
                    </div>
                    <p className="text-background-50/70 text-sm mt-6 font-light tracking-wider">
                      信息撮合 安全可靠
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-background-50/60">
        <span className="text-xs tracking-widest uppercase">向下滚动</span>
        <i className="ri-arrow-down-line text-lg animate-bounce"></i>
      </div>
    </section>
  );
}